import { Button, Hamburger, Row } from 'hatch-components';
import Select from 'root/components/molecules/Select';
import styled from 'styled-components';

export const LOGGED_IN_HEADER_HEIGHT = 64;

export const StyledDefaultTemplateHeader = styled(Row)(
  ({
    theme: {
      spacing,
      colors,
      responsive: { mobile },
    },
  }) => ({
    alignItems: 'center',
    background: colors.white,
    borderBottom: `1px solid ${colors.lightGrey}`,
    flexWrap: 'nowrap',
    height: `${LOGGED_IN_HEADER_HEIGHT}px`,
    justifyContent: 'space-between',
    [mobile]: {
      padding: `0 ${spacing.sm}`,
    },
    padding: `0 ${spacing.md}`,
    width: '100%',
  }),
);

export const StyledDefaultTemplateHeaderLeft = styled(Row)(() => ({
  alignItems: 'center',
  flex: 1,
  flexWrap: 'nowrap',
}));

export const StyledButton = styled(Button)(
  ({
    theme: {
      spacing,
      responsive: { mobile },
    },
  }) => ({
    display: 'none',
    [mobile]: {
      alignItems: 'center',
      display: 'flex',
      height: spacing.xxl,
      justifyContent: 'center',
      marginRight: spacing.sm,
      padding: 0,
      svg: {
        height: spacing.md,
        marginRight: 0,
        width: spacing.md,
      },
      width: '36px',
    },
  }),
);

export const StyledHamburgerMenu = styled(Hamburger)(
  ({
    theme: {
      responsive: { mobile },
    },
  }) => ({
    display: 'none',
    [mobile]: {
      display: 'flex',
    },
  }),
);

export const StyledTitle = styled.h1(
  ({
    theme: {
      colors,
      font,
      responsive: { mobile },
    },
  }) => ({
    color: colors.secondary,
    fontSize: font.size.xl,
    fontWeight: font.weight.semibold,
    lineHeight: font.lineHeight.xl,
    maxWidth: '100%',
    [mobile]: {
      fontSize: font.size.sm,
      fontWeight: font.weight.bold,
      lineHeight: font.lineHeight.sm,
    },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
);

export const StyledSelect = styled(Select)(() => ({
  '.rs__control': {
    minHeight: 38,
  },
  marginBottom: 0,
  minHeight: 38,
}));
